// Auto-generated lightweight class for ToolCallResponse
// DO NOT EDIT - Changes will be overwritten

import { NeoNodeBase } from '@sourcepilot/framework/neo-node-base';
import { RelationshipManager } from '@sourcepilot/framework/relationship-manager';
import { Relationship } from '@sourcepilot/framework/relationship';
import { ToolCallResponseReadAPI, ToolCallResponseWriteAPI, ToolCallResponseReadAPISchema, ToolCallResponseWriteAPISchema } from '../types/toolcallresponse';
import { ModelRegistry } from '../../registries/model-registry';
import { AtScope, HasContentObject, HasResponse, ToolResponsesSentIn } from '../../relationships/relationship';

import { SecurityScope } from '../../shared/api/securityscope';
import { ModelRequest } from './modelrequest';
import { ToolCallPart } from './toolcallpart';
import { ScopedNode } from '../../shared/api/scopednode';



export interface ToolCallResponse extends Partial<ToolCallResponseReadAPI> {}
export class ToolCallResponse extends NeoNodeBase<ToolCallResponseReadAPI, ToolCallResponseWriteAPI> {
  // Static label for identifying this model type (minification-safe)
  static readonly label = "ToolCallResponse";
  static readonly readSchema = ToolCallResponseReadAPISchema;
  static readonly writeSchema = ToolCallResponseWriteAPISchema;

  // Per-relationship metadata, keyed by property name on this class.
  // See `framework/data/dag-sync/reverse-property.ts` for how the DAG
  // client uses (relClass, direction) to route patches back to the
  // correct property — especially for polymorphic-source rels.
  static readonly relationships: Record<string, {
    target: string;
    cardinality: 'one' | 'many';
    isParent: boolean;
    relClass: string;
    direction: 'in' | 'out';
  }> = {
    sent_in_request: { target: "ModelRequest", cardinality: "one", isParent: false, relClass: "ToolResponsesSentIn", direction: "out" },
    tool_call: { target: "ToolCallPart", cardinality: "one", isParent: true, relClass: "HasResponse", direction: "in" },
    content_objects: { target: "ScopedNode", cardinality: "many", isParent: false, relClass: "HasContentObject", direction: "out" },
  };

  protected get modelName(): string {
    return 'ToolCallResponse';
  }

  // Instance getter for label (used in DAG sync and type identification)
  get _label(): string {
    return ToolCallResponse.label;
  }


  constructor(data: Partial<ToolCallResponseWriteAPI> = {}) {
    super(data);
  }

/**
   * Load instance from server data with Zod validation
   * Recursively instantiates nested relationship objects
   *
   * @param data - Node data from API (ReadAPI format)
   * @param loadContext - Optional LoadContext from backend QueryResult for eager-loaded relationships
   * @returns Class instance with nested relationships instantiated
   */
  static load(data: ToolCallResponseReadAPI, loadContext?: Record<string, any>): ToolCallResponse {
    // Import relationship loaders
    const { loadOneRelationship, loadManyRelationship } = require('@sourcepilot/framework/load-relationship');

    // Strip relationship fields before validation (they'll be processed separately)
    const { tool_call, security_scope, sent_in_request, content_objects, _label, ...dataToValidate } = data as any;

    // Validate with Zod schema (only non-relationship fields)
    const validated = ToolCallResponseReadAPISchema.parse(dataToValidate);

    // Re-add relationship fields to validated data for processing
    const dataWithRelationships: any = { ...validated, tool_call: tool_call, security_scope: security_scope, sent_in_request: sent_in_request, content_objects: content_objects };

    // If loadContext provided, use NeoGraphParser to reconstruct relationships
    if (loadContext && validated.id) {
      // Import NeoGraphParser dynamically to avoid circular dependencies
      const { NeoGraphParser } = require('@sourcepilot/framework/neograph-utils');
      const parser = new NeoGraphParser();
      const graphNodes = parser.parse([validated], loadContext);

      if (graphNodes.length > 0) {
        // Convert graph structure back to plain object with relationships
        const withRelationships = parser.toPlainObject(graphNodes[0]);
        // Recursively instantiate via ModelRegistry (without loadContext to avoid infinite loop)
        return ToolCallResponse.load(withRelationships);
      }
    }

    // Recursively instantiate nested relationships from inline data
    const processed: any = { ...dataWithRelationships };

    // Process relationships: convert to class instances and store with private property names
    loadOneRelationship(processed, 'tool_call', 'ToolCallPart', ModelRegistry);
    loadOneRelationship(processed, 'security_scope', 'SecurityScope', ModelRegistry);
    loadOneRelationship(processed, 'sent_in_request', 'ModelRequest', ModelRegistry);
    loadManyRelationship(processed, 'content_objects', 'ScopedNode', ModelRegistry);
    // Create instance with processed data (constructor uses Object.assign)
    // Private properties (_*) won't conflict with relationship getters
    const instance = new ToolCallResponse(processed as any);

    return instance;
  }


  // Relationship manager for 'security_scope' - Python ORM style (cached)
  get security_scope(): RelationshipManager<this, SecurityScope> {
    return this.getOrCreateRelationshipManager('security_scope', () => {
      return new RelationshipManager(this, 'security_scope', 'one', AtScope as typeof Relationship);
    });
  }

  // Relationship manager for 'sent_in_request' - Python ORM style (cached)
  get sent_in_request(): RelationshipManager<this, ModelRequest> {
    return this.getOrCreateRelationshipManager('sent_in_request', () => {
      return new RelationshipManager(this, 'sent_in_request', 'one', ToolResponsesSentIn as typeof Relationship);
    });
  }

  // Relationship manager for 'tool_call' - Python ORM style (cached)
  get tool_call(): RelationshipManager<this, ToolCallPart> {
    return this.getOrCreateRelationshipManager('tool_call', () => {
      return new RelationshipManager(this, 'tool_call', 'one', HasResponse as typeof Relationship);
    });
  }

  // Relationship manager for 'content_objects' - Python ORM style (cached)
  get content_objects(): RelationshipManager<this, ScopedNode> {
    return this.getOrCreateRelationshipManager('content_objects', () => {
      return new RelationshipManager(this, 'content_objects', 'many', HasContentObject as typeof Relationship);
    });
  }

}
